import styled from "styled-components"

const SubsectionArrow = styled.div`
  transform: rotate(-90deg);
  background: transparent;
`

export { SubsectionArrow as default }


// WEBPACK FOOTER //
// ./assets/common/components/ProfileSwitcher/components/SubsectionArrow.js